<template>
    <div class="col-12 nopads">
      <b-navbar class="no-gutters">
        <b-col lg="7" md="12" class="mx-auto no-gutters">
          <b-navbar class="no-gutters">
            <!-- Logo in center -->
            <b-navbar-brand class="top-logo-container" @click="backToMain">
              <img class="mx-auto top-logo" src="../assets/logo.png" alt="fair-logo"/>
            </b-navbar-brand>
            <!-- Left aligned items -->
            <b-navbar-nav>
              <b-nav-item class="left-nav-item" v-if="$store.state.token || hideLogin" lef href="#"
              >
                <b-button class="top-bar-search-btn" @click.stop="backToMain">
                  <font-awesome-icon icon="home" size="lg"/>
                  <span class="menu-text-under d-none d-md-block">{{ $t('common.home') }}</span>
                </b-button>
              </b-nav-item>
              <b-nav-item class="left-nav-item" v-else href="#">
                <b-button class="top-bar-search-btn" @click.stop="backToMain">
                  <font-awesome-icon icon="user-circle" size="lg" />
                  <span class="menu-text-under d-none d-md-block">{{ $t('login.login') }}</span>
                </b-button>
              </b-nav-item>
            </b-navbar-nav>
            <b-navbar-nav class="ml-auto"  >
                <b-nav-form>
                    <b-input-group>
                        <b-form-input v-model="query" @keypress.enter.prevent=""/>
                        <b-input-group-append>
                            <b-button class="top-bar-clean-btn" @click.stop="clean">
                                <font-awesome-icon icon="times" />
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-nav-form>
            </b-navbar-nav>
        </b-navbar>
        </b-col>
      </b-navbar>
        <div class="col-12 main-container">
            <div class="col-xl-10 content-container mx-auto">
                <!-- Tabs -->
                <b-row class="col-12 nopads mt-6">
                    <div class="col-4 no-gutters search-tab-container">
                        <div
                                class="col-12 no-gutters fair-tab align-bottom"
                                v-bind:class="{ active_tab: activeTab===1}"
                                @click.stop="setView(1)">
                            <span class="tab-title">{{ $t('search.tab_all')}}</span>
                        </div>
                    </div>
                    <div class="col-4 no-gutters search-tab-container">
                        <div
                                class="col-12 nopads fair-tab align-bottom"
                                v-bind:class="{ active_tab: activeTab===2}"
                                @click.stop="setView(2)">
                            <span class="tab-title">{{ $t('search.tab_teams')}}</span>
                        </div>
                    </div>
                    <div class="col-4 no-gutters search-tab-container">
                        <div
                                class="col-12 nopads fair-tab align-bottom"
                                v-bind:class="{ active_tab: activeTab===3}"
                                @click.stop="setView(3)">
                            <span class="tab-title">{{ $t('search.tab_members')}}</span>
                        </div>
                    </div>
                </b-row>
                <transition name="fade">
                    <div class="mx-auto mt-4 no-gutters">
                        <transition name="fade" v-if="activeTab === 1 || activeTab === 2">
                            <found-team-list :teams="filteredTeamResults"/>
                        </transition>
                        <transition name="fade" v-if="activeTab === 1 || activeTab === 3">
                            <found-member-list :members="filteredMemberResults"/>
                        </transition>
                        <b-row v-if="noResults">
                            <span class="col-12 no-results" v-if="!loading">
                                    {{ $t('common.no_results') }}
                            </span>
                        </b-row>
                    </div>
                </transition>
            </div>
            <footer-area />
        </div>
        <div v-if="loading"
             id="loader"
             class="spinner">
        </div>
    </div>

</template>

<script>
    import FairApi from "../modules/api";
    import FoundTeamList from "../components/search/FoundTeamList";
    import FoundMemberList from "../components/search/FoundMemberList";
    import {userHelper} from "../mixins/UserMixin";
    import {views} from "../mixins/ViewMixin";
    import FooterArea from "@/components/FooterArea";

    export default {
        name: "search-view",
        mixins: [userHelper, views],
        components: {FooterArea, FoundMemberList, FoundTeamList},
        props: {
          hideLogin: {
            type: Boolean,
            default() {
              return false
            }
          },
          hideSearch: {
            type: Boolean,
            default() {
              return false
            }
          }
        },
        data() {
            return {
                query: '',
                teamList: [],
                loading: false,
                activeTab: 1
            }
        },

        created() {
            this.fetchTeams()
        },

        computed: {
            filteredTeamResults: function () {
                if (this.teamList.length > 0) {
                    return this.findBy(this.teamList, this.query, 'name')
                }
                return []
            },

            filteredMemberResults: function () {
                if (this.teamList.length > 0) {
                    return this.findMatchingMembers()
                }
                return []
            },

            noResults: function () {
                return this.filteredTeamResults.length < 1 && this.filteredMemberResults.length < 1 ||
                        this.activeTab === 2 && this.filteredTeamResults.length < 1 ||
                        this.activeTab === 3 && this.filteredMemberResults.length < 1
            },
        },

        methods: {
            setView(tab) {
                this.activeTab = tab
            },

            findMatchingMembers: function () {
                let matchingMembers = []
                let shortTeamList = JSON.parse(JSON.stringify(this.teamList))
                shortTeamList.forEach(team => {
                    if (team.team.members.length > 0) {
                        team.team.members.forEach(member => {
                            if ((member.first_name.toLowerCase().includes(this.query.toLowerCase())) ||
                                (member.last_name.toLowerCase().includes(this.query.toLowerCase())) ||
                                (team.team.name.toLowerCase().includes(this.query.toLowerCase()))) {
                                matchingMembers.push(member)
                            }
                        })
                    }
                })
                return matchingMembers
            },

            findBy: function (list, value, column) {
                return list.filter(function (item) {
                    if (item.team[column].toLowerCase().includes(value.toLowerCase())) {
                        return true
                    }
                })
            },

            fetchTeams: function () {
                this.loading = true
                FairApi.get(FairApi.teamNearby(), this.success, this.failed)
            },

            success: function (response) {
                this.teamList = response
                this.loading = false
            },

            failed: function () {
                this.loading = false
            },

            clean: function () {
                if (this.query === '') {
                  this.backToMain();
                }
                this.query = ''
            },

            backToMain: function () {
                this.$router.push({name: 'main-view'})
            }

        }
    }
</script>

<style scoped>

</style>